import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { closeChildViewports } from '../../../util/openChildViewport';
import { isChildViewport } from '../../../util/isChildViewport';

const getViewerRouteKey = (pathname) => {
  const match = pathname.match(/\/viewer\/(study|access|patient)\/([^/]+)/);
  return match ? `${match[1]}:${match[2]}` : null;
};

const ChildViewportLifecycle = () => {
  const location = useLocation();
  const mainStudyId = useSelector((state) => state.patient.mainStudyId);
  const isChildWindow = isChildViewport();
  const previousPathname = useRef(location.pathname);
  const previousStudyId = useRef(mainStudyId);

  useEffect(() => {
    const previousRouteKey = getViewerRouteKey(previousPathname.current);
    const currentRouteKey = getViewerRouteKey(location.pathname);
    const routeChanged = previousPathname.current !== location.pathname;

    if (isChildWindow) {
      if (routeChanged && (previousRouteKey || currentRouteKey)) {
        window.close();
      }
    } else {
      if (routeChanged && (previousRouteKey || currentRouteKey)) {
        closeChildViewports();
      }

      if (previousStudyId.current && mainStudyId && previousStudyId.current !== mainStudyId) {
        closeChildViewports();
      }
    }

    previousPathname.current = location.pathname;
    previousStudyId.current = mainStudyId;
  }, [isChildWindow, location.pathname, mainStudyId]);

  useEffect(() => {
    const handlePageHide = () => {
      if (isChildWindow) window.close();
      else closeChildViewports();
    };

    window.addEventListener('pagehide', handlePageHide);
    return () => window.removeEventListener('pagehide', handlePageHide);
  }, [isChildWindow]);

  return null;
};

export default ChildViewportLifecycle;
